export default __webpack_public_path__ + "static/media/mainPattern.844d9688.png";